import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { portalConst } from '@app/config';
import { Attachment } from '@app/core/models';
import { SHARED_MODULES } from '@app/shared';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { UploadFileComponent } from '@app/shared/modules/upload-file/upload-file.component';

@Component({
  selector: 'app-modal-review-feedback-file',
  imports: [SHARED_MODULES, UploadFileComponent],
  templateUrl: './modal-review-feedback-file.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalReviewFeedbackFileComponent {
  @Output() public close = new EventEmitter<Attachment[]>();

  public config: DropzoneConfigInterface = {
    clickable: true,
    url: `${portalConst.api.eclass}/v1/upload/attachment`,
    createImageThumbnails: false,
    maxFiles: 1,
    maxFilesize: 30,
    acceptedFiles: '.pdf,.mp3,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.jpg,.jpeg,.png,.pdf,.txt',
    previewsContainer: false,
    params: { folder: 'feedbacks' },
  };

  private _files: Attachment[] = [];

  public onClose() {
    this.close.emit();
  }

  public onUpload(data: any) {
    this.close.emit(data);
  }
}
